import CourseCard from '@components/V3/CourseCard';
import SkeletonBox from '@components/V4/SkeletonBox';
import { Course } from '@shared/common';
import { useLoginAndRedirectToCourse } from '@actions';
import useToast from 'apps/agora/src/hooks/useToast';
import { mergeClassNames } from 'apps/agora/src/utils/helpers';
interface CoursesSectionProps {
  courses?: Partial<Course>[];
  isLoading: boolean;
}
const CoursesSection = (props: CoursesSectionProps) => {
  const { courses, isLoading } = props;
  const toast = useToast();

  const { mutate: redirectToLMS } = useLoginAndRedirectToCourse({
    onSuccess: (data) => {
      if (data?.url) {
        setTimeout(() => {
          window.open(data.url, '_blank');
        });
      }
    },
    onError: () => {
      toast.error('Failed to redirect to LMS!');
    },
  });

  const courseClickHandler = (course: Partial<Course>) => {
    if (!course?.lmsCourseId) return;
    redirectToLMS({ courseId: course.lmsCourseId });
  };

  return (
    <section className="grid gap-4 grid-cols-1 tablet:grid-cols-2 largeLaptop:grid-cols-3">
      {!!courses?.length &&
        !isLoading &&
        courses?.map((course) => (
          <div
            key={course._id}
            className={mergeClassNames('cursor-pointer', {
              'cursor-default': !course.lmsCourseId,
            })}
            onClick={() => courseClickHandler(course)}
          >
            <CourseCard
              image={course?.headerImage?.['160x160'] ? course.headerImage['160x160'] : null}
              title={course?.title}
              subtitle={course.subtitle}
              color={course.color}
              hasLMSCourseID={!!course.lmsCourseId}
            />
          </div>
        ))}

      {isLoading &&
        [...Array(9).keys()].map((_, index) => (
          <SkeletonBox key={index} className="w-full min-w-17 min-h-28" />
        ))}
    </section>
  );
};

export default CoursesSection;
